/**
 * Shared sizing for modals that hold a form (add / edit resource, service, company…).
 * The body scrolls instead of the page so `FormModalFooter` can stick to its bottom edge.
 */
export const FORM_MODAL_STYLES = {
  body: {
    maxHeight: 'calc(100dvh - 180px)',
    overflowY: 'auto' as const,
    overflowX: 'hidden' as const
  }
};

/** Modal width that never exceeds the viewport minus a 16px gutter on each side. */
export function formModalWidth(maxWidth: number): string {
  return `min(${maxWidth}px, calc(100vw - 32px))`;
}
